// @flow

import React from "react";
import { localize } from "redux-i18n";
import { View, Text, SchemaTable } from "@components";
import type { HierarchyAssignment } from "@modules/service/types";
import schema from "./schema";
import { uiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  assignments: Array<HierarchyAssignment>,
  editing: boolean,
  onChange?: (assignments: Array<Object>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class HierarchyScopeAreasIncluded extends React.Component<Props> {
  get data() {
    return this.props.assignments.map(i => {
      return {
        activeFrom: i.activeFrom,
        activeTo: i.activeTo,
        target: i.target.label,
      };
    });
  }

  handleChange = (data: Array<Object>) => {
    if (this.props && this.props.onChange) {
      this.props.onChange(data);
    }
  };

  render() {
    return (
      <View>
        <Text type="h6" text={this.props.t("HIERARCHY_SCOPE_AREAS_INCLUDED")} />
        {!!this.props?.assignments?.length && (
          <SchemaTable
            tableData={this.data}
            schema={schema}
            uiSchema={uiSchema(this.props.t)}
            onChange={this.handleChange}
            disabled={!this.props.editing}
            allowDeletes
          />
        )}
      </View>
    );
  }
}

export default localize()(HierarchyScopeAreasIncluded);
